import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "../css/projects.css";
import yoga from "../assets/imgs/yogaWithGemini.png";
import familyTree from "../assets/imgs/familytree.png";
import hiring from "../assets/imgs/hiring.png";
import netflix from "../assets/imgs/netflixClone.png";
import construct from "../assets/imgs/construction.png";
import homeServices from "../assets/imgs/homeServices.png";
import git from "../assets/imgs/github.png";
import link from "../assets/imgs/external-link.png";

const projectList = [
  {
    title: "Yoga with Gemini",
    image: yoga,
    description: "Personal Yoga application with Gemini AI integrated",
    github: "https://github.com/binduthotal/yoga-fitness-app",
    live: "https://yogawithgemini-10627.firebaseapp.com/",
  },
  {
    title: "Home Services",
    image: homeServices,
    description:
      "Home Services app is developed using react providing all the home services to the users",
    github: "https://github.com/binduthotal/HomeServicesFirebase",
    live: "https://fir-app-47705.web.app/",
  },
  {
    title: "Family Tree",
    image: familyTree,
    description: "A Family Tree application developed using Js and D3 library",
    github: "https://github.com/binduthotal/jsFamilyTree",
    live: "https://jsfamilytree.web.app/",
  },
  {
    title: "Hiring",
    image: hiring,
    description:
      "A recruitment platform designed to bridge the gap between employers and job seekers.",
    github: "https://github.com/binduthotal/hiring-app",
    live: "https://hiring-app-eight.vercel.app/",
  },
  {
    title: "Construction",
    image: construct,
    description:
      "This app offers a variety of houses designed to improve living spaces.",
    github: "https://github.com/binduthotal/construction-app",
    live: "https://construction-app-jade.vercel.app/",
  },
  {
    title: "Netflix Clone",
    image: netflix,
    description:
      "The Netflix clone app uses the Gemini API to search for movies based on user preferences.",
    github: "https://github.com/binduthotal/movieflix-gpt",
    live: "https://movieflix-gpt-beta.vercel.app/",
  },
];

const Projects = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <section
      className="w-full scroll-mt-15 px-5 py-24 md:px-16 lg:px-24"
      id="projects"
    >
      <div className="mx-auto max-w-6xl">
        <p className="text-center font-mono text-lg uppercase tracking-[0.35em] text-zinc-500">
          Projects
        </p>
        <h2 className="mt-4 text-center font-mono text-3xl font-semibold text-white md:text-4xl">
          Showcase of My Accomplished Projects
        </h2>
        <p className="mx-auto mt-4 max-w-3xl text-center text-base leading-7 text-zinc-300 md:text-lg">
          A selection of projects focused on responsive design, practical user
          flows, and frontend problem solving with modern web tools.
        </p>

        <div
          data-aos="fade-up"
          className="mt-12 grid gap-8 md:grid-cols-2 xl:grid-cols-3"
        >
          {projectList.map((project) => (
            <article key={project.title} className="project-card">
              <div className="group">
                <img
                  className="projectImgs"
                  src={project.image}
                  alt={project.title}
                />
                <div className="onGroup-Hover group-hover:block rounded-[18px]">
                  <div className="onGroup-Hover-toDisplay">
                    <a
                      className="project-link-icon"
                      target="_blank"
                      rel="noreferrer"
                      href={project.github}
                    >
                      <img className="h-7 w-7" src={git} alt="git hub" />
                    </a>
                    <a
                      className="project-link-icon"
                      href={project.live}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img className="h-7 w-7" src={link} alt="external link" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">
                  Featured Work
                </p>
                <h3 className="mt-2 font-mono text-xl font-semibold text-white">
                  {project.title}
                </h3>
                <p className="project-decrp mt-3 text-zinc-300">
                  {project.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
